import { Box } from "@mui/system";
import { useNotificationRuntime } from "./notification-runtime-context";

export const NotificationOutlet = () => {
  const { activeCandidate } = useNotificationRuntime();

  return (
    <Box
      id="NOTIFICATION-SERVICE"
      sx={{
        height: "fit-content",
        position: "absolute",
        zIndex: "10",
      }}
    >
      {activeCandidate?.render() ?? null}
    </Box>
  );
};
